"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  textBox: {
    boxShadow: theme.shadows[25].z8,
    padding: theme.spacing(3)
  }
}));
const ImageText = props => {
  const {
    addition2: headline,
    media,
    text,
    title: subTitle,
    option: alignment = 0
  } = props.data;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = useStyles();
  const {
    filename,
    alt,
    height,
    width
  } = (0, _lodash.first)(media);
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 4,
    style: {
      order: alignment
    }
  }, /*#__PURE__*/_react.default.createElement(_image.default, {
    filename: filename && REACT_APP_PATH + filename,
    alt: alt,
    height: height,
    width: width
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 8,
    className: css.textBox
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "secondary",
    dangerouslySetInnerHTML: {
      __html: headline
    },
    variant: "h3"
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: subTitle
    },
    variant: "h4"
  }), /*#__PURE__*/_react.default.createElement(_Box.default, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    dangerouslySetInnerHTML: {
      __html: text
    }
  })))));
};
var _default = exports.default = ImageText;